import confetti from 'canvas-confetti';

// Gold confetti celebration for streak milestones
export const celebrateStreakMilestone = (milestone) => {
  const duration = 4000;
  const animationEnd = Date.now() + duration;
  
  // Gold color palette for luxurious feel
  const goldColors = ['#C6A75E', '#D4B86E', '#E5C985', '#B8975A', '#A88B4A'];
  
  const randomInRange = (min, max) => Math.random() * (max - min) + min;

  // Initial burst
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
    colors: goldColors,
    shapes: ['circle', 'square'],
    scalar: 1.2,
  });

  // Continuous gold rain
  const interval = setInterval(() => {
    const timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      clearInterval(interval);
      return;
    }

    const particleCount = 50 * (timeLeft / duration);

    // Left side
    confetti({
      particleCount: Math.floor(particleCount / 2),
      angle: 60,
      spread: 55,
      origin: { x: 0, y: 0.6 },
      colors: goldColors,
      ticks: 300,
      gravity: 0.8,
      scalar: randomInRange(0.9, 1.3),
      drift: 0,
    });

    // Right side
    confetti({
      particleCount: Math.floor(particleCount / 2),
      angle: 120,
      spread: 55,
      origin: { x: 1, y: 0.6 },
      colors: goldColors,
      ticks: 300,
      gravity: 0.8,
      scalar: randomInRange(0.9, 1.3),
      drift: 0,
    });
  }, 250);

  // Return cleanup function
  return () => clearInterval(interval);
};

// Subtle celebration for completing all daily actions
export const celebrateAllActionsComplete = () => {
  confetti({
    particleCount: 50,
    spread: 60,
    origin: { y: 0.7 },
    colors: ['#8BAA9E', '#A3C2B6', '#C6A75E'],
    scalar: 0.8,
    ticks: 200,
  });
};

// Check if user hit a new milestone
export const checkMilestoneReached = (currentStreak, previousStreak) => {
  const milestones = [7, 30, 90];
  
  for (const milestone of milestones) {
    if (currentStreak >= milestone && previousStreak < milestone) {
      return milestone;
    }
  }
  return null;
};

// Get milestone message
export const getMilestoneMessage = (milestone) => {
  switch (milestone) {
    case 7:
      return { title: 'Week Warrior!', subtitle: '7-day streak achieved!' };
    case 30:
      return { title: 'Monthly Master!', subtitle: '30-day streak achieved!' };
    case 90:
      return { title: 'Transformation Titan!', subtitle: '90-day streak achieved!' };
    default:
      return null;
  }
};
